import { render } from "./SearchDepositModal.vue?vue&type=template&id=98912fcc&ts=true"
import script from "./SearchDepositModal.vue?vue&type=script&lang=ts"
export * from "./SearchDepositModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__